module.exports = __webpack_public_path__ + "img/PGR_A03_back_en.61e2b1ff.png";